import { capitalCase } from "change-case";

import {
  ColorVariant,
  colorVariants,
} from "@/components/canvas-editor/components/Container";
import { ColorPreview } from "@/components/ColorPreview";
import { Label } from "@/components/ui/label";
import { SimpleSelect } from "@/components/ui/select";

export function ColorSelect({
  defaultValue = "purple",
  label,
  onChange,
}: {
  defaultValue?: ColorVariant;
  label: string;
  onChange: (value: ColorVariant) => void;
}) {
  return (
    <div className="flex flex-col gap-3">
      <Label htmlFor="color">{label}</Label>
      <SimpleSelect
        name="color"
        id="color"
        aria-label={label}
        defaultValue={defaultValue}
        onValueChange={(value) => onChange(value as ColorVariant)}
        options={colorVariants.map((color) => ({
          label: (
            <div className="flex items-center gap-2">
              <ColorPreview color={color} />
              {capitalCase(color)}
            </div>
          ),
          value: color,
        }))}
      />
    </div>
  );
}
